// 🔥 www → non-www 리다이렉트 (최상단에서 즉시 실행)
if (window.location.hostname === 'www.mytoolb2b.link') {
    window.location.replace('https://mytoolb2b.link' + window.location.pathname + window.location.search);
}

import { createApp } from 'vue/dist/vue.esm-bundler.js';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';

import './assets/styles/global.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';

// Chart.js import 추가
import 'chart.js/auto';

// AG Grid
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import 'ag-grid-community/styles/ag-theme-balham.css';

import { ModuleRegistry } from 'ag-grid-community';
import { ClientSideRowModelModule, PaginationModule } from 'ag-grid-community';
ModuleRegistry.registerModules([ClientSideRowModelModule, PaginationModule]);

// 스타일
import './assets/styles/shop.css';
import './assets/styles/admin.css';

// 🔥 이미지 헬퍼 import
import { getImageUrl, getDefaultImage, handleImageError, setupImageErrorHandling } from '@/utils/imageHelper.js';

const app = createApp(App);

// 🔥 글로벌 이미지 처리 함수들
app.config.globalProperties.$getImageUrl = getImageUrl;
app.config.globalProperties.$getDefaultImage = getDefaultImage;
app.config.globalProperties.$handleImageError = handleImageError;
app.config.globalProperties.$getUploadUrl = getUploadUrl;

// 🔥 자동 이미지 오류 처리 설정
app.config.globalProperties.$setupImageErrorHandling = setupImageErrorHandling;

// API URL 폴백 설정 함수
function getApiBaseUrl() {
    const hostname = window.location.hostname;
    const port = window.location.port;
    const isAdminPage = window.location.pathname.startsWith('/admin');

    console.log('🌐 현재 호스트:', hostname, '포트:', port, '관리자페이지:', isAdminPage);

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        console.log('🔧 로컬 개발 환경 감지');
        return 'http://localhost:8080';
    } else if (hostname === '13.125.54.204') {
        console.log('🚀 EC2 IP 직접 접속 감지');
        return 'http://13.125.54.204:8080';
    } else if (hostname.includes('mytoolb2b.link')) {
        console.log('🌍 도메인 환경 감지 - mytoolb2b.link');

        if (process.env.NODE_ENV === 'production') {
            console.log('🚀 프로덕션 환경 - HTTPS API 사용');
            return 'https://mytoolb2b.link';
        } else {
            console.log('🔧 개발 환경 - 폴백 API 사용');
            return process.env.VUE_APP_FALLBACK_API_URL || 'http://13.125.54.204:8080';
        }
    } else {
        console.log('❓ 기타 환경 감지, 폴백 API 사용');
        return process.env.VUE_APP_FALLBACK_API_URL || 'http://13.125.54.204:8080';
    }
}

// 🔥 글로벌 업로드 URL 생성 함수 추가 (기존 함수 유지)
function getUploadUrl(endpoint = '/api/admin/upload') {
    const baseUrl = getApiBaseUrl();
    return `${baseUrl}${endpoint}`;
}

// axios 기본 설정
const apiBaseUrl = getApiBaseUrl();
axios.defaults.baseURL = apiBaseUrl;
axios.defaults.headers.common['Content-Type'] = 'application/json';

console.log('✅ API Base URL 설정:', apiBaseUrl);

// 🔥 요청 인터셉터
axios.interceptors.request.use(
    (config) => {
        const isAdminPage = window.location.pathname.startsWith('/admin');

        let token = null;
        if (isAdminPage) {
            token = localStorage.getItem('adminToken') || sessionStorage.getItem('adminToken');
            if (!token) {
                const userToken = localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token');
                if (userToken) {
                    console.log('🚨 일반 사용자 토큰이 있지만 관리자 페이지에서 무시됨');
                }
            }
        } else {
            token = localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token');
            if (!token) {
                const adminToken = localStorage.getItem('adminToken') || sessionStorage.getItem('adminToken');
                if (adminToken) {
                    console.log('🚨 관리자 토큰이 있지만 일반 페이지에서 무시됨');
                }
            }
        }

        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }

        console.log('🔥 API 요청:', config.method.toUpperCase(), config.url);
        console.log('🔥 페이지 타입:', isAdminPage ? '관리자' : '일반');
        console.log('🔥 토큰 상태:', token ? '있음' : '없음');

        return config;
    },
    (error) => {
        console.error('🔥 요청 인터셉터 오류:', error);
        return Promise.reject(error);
    }
);

// 🔥 응답 인터셉터 (401 에러 처리)
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        console.error('🔥 API 응답 오류:', error.response?.status, error.response?.data);

        if (error.response && error.response.status === 401) {
            console.log('🔥 인증 오류 발생 - 토큰 정리 중...');

            const isAdminPage = window.location.pathname.startsWith('/admin');

            if (isAdminPage) {
                localStorage.removeItem('adminToken');
                sessionStorage.removeItem('adminToken');
                localStorage.removeItem('auth_token');
                sessionStorage.removeItem('auth_token');

                if (router.currentRoute.value.path !== '/admin/login') {
                    alert('인증에 실패했습니다. 다시 로그인해주세요.');
                    router.push('/admin/login');
                }
            } else {
                localStorage.removeItem('auth_token');
                sessionStorage.removeItem('auth_token');

                if (router.currentRoute.value.path !== '/login') {
                    alert('인증에 실패했습니다. 다시 로그인해주세요.');
                    router.push('/login');
                }
            }
        }

        return Promise.reject(error);
    }
);

// �� 모든 이미지 URL을 자동으로 변환하는 함수 추가 (위로 이동)
function transformAllImageUrls() {
    const images = document.querySelectorAll('img');
    const apiBaseUrl = getApiBaseUrl();

    images.forEach(img => {
        if (img.src && !img.src.startsWith('data:') && !img.src.startsWith('blob:')) {
            // localhost:8080을 운영서버 URL로 변환
            if (img.src.includes('localhost:8080')) {
                const newSrc = img.src.replace('http://localhost:8080', apiBaseUrl);
                img.src = newSrc;
                console.log('🔄 이미지 URL 변환:', img.src, '→', newSrc);
            }
        }
    });
}

// 🔥 페이지 이동 시 이미지 오류 처리 재설정
router.afterEach(() => {
    setTimeout(() => {
        // 스크롤 초기화
        window.scrollTo({ top: 0, behavior: 'auto' });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;

        if (window.pageYOffset !== undefined) {
            window.pageYOffset = 0;
        }

        // 🔥 이미지 오류 처리 재설정
        setupImageErrorHandling();
        transformAllImageUrls();

        // 🔥 페이지 제목 업데이트
        updatePageTitle();
    }, 150);
});

// 🔥 사이트 제목 로드 및 업데이트 함수
async function loadSiteTitle() {
    try {
        const response = await axios.get('/api/config/store');
        if (response.data && response.data.name) {
            document.title = response.data.name;
            console.log('✅ 사이트 제목 업데이트:', response.data.name);
        } else {
            console.log('⚠️ 사이트 제목이 설정되지 않음, 기본값 사용');
            document.title = '마이툴 - 공구 쇼핑몰';
        }
    } catch (error) {
        console.error('❌ 사이트 제목 로드 실패:', error);
        document.title = '마이툴 - 공구 쇼핑몰';
    }
}

// 🔥 페이지별 제목 업데이트 함수
function updatePageTitle() {
    const currentPath = router.currentRoute.value.path;

    // 관리자 페이지인 경우
    if (currentPath.startsWith('/admin')) {
        loadSiteTitle().then(() => {
            const currentTitle = document.title;
            document.title = `관리자 - ${currentTitle}`;
        });
    } else {
        // 일반 사용자 페이지
        loadSiteTitle();
    }
}

app.config.globalProperties.$axios = axios;

app.use(router);
app.use(store);

// 🔥 앱 마운트 후 이미지 오류 처리 설정
app.mount('#app');

// 🔥 DOM 로드 완료 후 자동 이미지 오류 처리 시작
document.addEventListener('DOMContentLoaded', () => {
    setupImageErrorHandling();
});

// 🔥 즉시 실행 (이미 DOM이 로드된 경우)
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        setupImageErrorHandling();
        transformAllImageUrls(); // 여기도 추가
    });
} else {
    setupImageErrorHandling();
    transformAllImageUrls(); // 여기도 추가
}